import { render, staticRenderFns } from "./DeletedReason.vue?vue&type=template&id=1229ea13&scoped=true&"
import script from "./DeletedReason.vue?vue&type=script&lang=js&"
export * from "./DeletedReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229ea13",
  null
  
)

export default component.exports